import {
  Truck, Plane, Ship, TrainFront, PackageCheck, Zap, Warehouse,
  Share2, FileCheck2, Boxes, Workflow, Globe2,
  Navigation, Headset, Wallet, UserCheck, ShieldCheck, Rocket, Network,
  MapPin, Map, MapPinned,
} from "lucide-react";

export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_b308829c-2eb6-4dae-9fba-fc5864dccfe1/artifacts/46p257jl_Picture1.jpg";

export const COMPANY = {
  name: "Agarwal Secure Packers & Movers",
  shortName: "Agarwal Secure",
  established: "1999",
  experience: "21+ Years",
  address: "1257/A, Housing Board Society, Sector 9, Gurgaon – 122001",
  email: "info@agarwalsecurepackers.com",
  mobiles: ["9311001159", "9971654137"],
  phone: "0124-6900023",
  whatsapp: "9311001159",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Track", to: "/track" },
  { label: "Blog", to: "/blog" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1780746658231-a62748dad43b",
  cargoShip: "https://images.unsplash.com/photo-1670121180583-39ab653a071c",
  truck: "https://images.unsplash.com/photo-1666196975350-a0501cbf708c",
  warehouse: "https://images.unsplash.com/photo-1664382953403-fc1ac77073a0",
  delivery: "https://images.pexels.com/photos/12725403/pexels-photo-12725403.jpeg",
  office: "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg",
};

// Real cargo ships sailing on the open sea, shot from different angles (for the hero crossfade)
const shipQ = "?auto=compress&cs=tinysrgb&w=1920";
export const SHIP_SLIDES = [
  `https://images.pexels.com/photos/9328777/pexels-photo-9328777.jpeg${shipQ}`,
  `https://images.pexels.com/photos/38325186/pexels-photo-38325186.jpeg${shipQ}`,
  `https://images.pexels.com/photos/19640833/pexels-photo-19640833.jpeg${shipQ}`,
  `https://images.pexels.com/photos/262353/pexels-photo-262353.jpeg${shipQ}`,
];

export const STATS = [
  { target: 21, suffix: "+", label: "Years Experience" },
  { target: 50000, suffix: "+", label: "Deliveries Completed" },
  { target: 100, suffix: "%", label: "On-Time Delivery" },
  { target: 200000, suffix: "+", label: "Happy Clients" },
];

export const SERVICES = [
  { icon: Truck, title: "Road Transportation", desc: "Nationwide road freight with a modern, GPS-enabled fleet for every load size." },
  { icon: Plane, title: "Air Freight", desc: "Fast, secure air cargo for time-critical shipments across the globe." },
  { icon: Ship, title: "Sea Freight", desc: "Cost-effective FCL & LCL ocean freight with end-to-end documentation." },
  { icon: TrainFront, title: "Rail Freight", desc: "Reliable, eco-friendly rail transport for bulk and containerised cargo." },
  { icon: PackageCheck, title: "Courier Services", desc: "Door-to-door parcel delivery with real-time tracking and proof of delivery." },
  { icon: Zap, title: "Express Delivery", desc: "Priority same-day and next-day delivery when speed matters most." },
  { icon: Warehouse, title: "Warehousing", desc: "Secure, climate-controlled storage with inventory management systems." },
  { icon: Share2, title: "Distribution", desc: "Efficient last-mile distribution networks tuned for your business." },
  { icon: FileCheck2, title: "Customs Clearance", desc: "Hassle-free import/export clearance handled by licensed experts." },
  { icon: Boxes, title: "Packers & Movers", desc: "Professional packing and relocation for homes and offices." },
  { icon: Workflow, title: "Supply Chain Management", desc: "Integrated, data-driven supply chain solutions end to end." },
  { icon: Globe2, title: "Import & Export", desc: "Seamless international trade logistics with full compliance." },
];

export const WHY_CHOOSE = [
  { icon: Navigation, title: "GPS Tracking", desc: "Live location updates on every consignment, 24/7." },
  { icon: Headset, title: "24/7 Support", desc: "A dedicated team ready to help at any hour." },
  { icon: Wallet, title: "Affordable Pricing", desc: "Transparent, competitive quotes with no hidden charges." },
  { icon: UserCheck, title: "Experienced Drivers", desc: "Trained, verified professionals behind every wheel." },
  { icon: ShieldCheck, title: "Safe Delivery", desc: "Multi-layer packing and full transit insurance." },
  { icon: Rocket, title: "Fast Delivery", desc: "Optimised routes for the quickest turnaround." },
  { icon: Network, title: "Pan India Network", desc: "A trusted footprint spanning every major city." },
];

export const SERVICE_AREAS = [
  { icon: MapPin, title: "Local", desc: "Within-city moves handled with care and speed." },
  { icon: Map, title: "State", desc: "Reliable inter-city relocation across every state." },
  { icon: MapPinned, title: "Pan India", desc: "Seamless door-to-door service nationwide." },
  { icon: Plane, title: "International", desc: "Global relocation and freight with full compliance." },
];

export const TESTIMONIALS = [
  {
    name: "Vikram Singh",
    role: "Homeowner, Gurgaon",
    quote: "They moved my 3BHK across the city without a single scratch. The packing was meticulous and the team was punctual and polite. Highly recommended.",
    rating: 5,
  },
  {
    name: "Anita Desai",
    role: "Operations Head, TechNova",
    quote: "We relocated our entire office over a weekend with zero downtime. Their coordination and tracking gave us complete peace of mind.",
    rating: 5,
  },
  {
    name: "Mohammed Farooq",
    role: "Exporter, Delhi",
    quote: "From customs clearance to final delivery, everything was transparent and on time. A truly professional logistics partner.",
    rating: 5,
  },
];

export const MANIFESTO = [
  { no: "01", title: "Care, packed in", text: "Every box is packed as if it were our own — multi-layer wrapping, sturdy cartons and a five-point safety protocol on every consignment." },
  { no: "02", title: "Moved with precision", text: "A GPS-enabled fleet and trained drivers mean your goods travel on optimised, monitored routes from pickup to doorstep." },
  { no: "03", title: "Trusted since 1999", text: "Twenty-one years, hundreds of thousands of happy clients and a 100% on-time record — trust that is earned, one move at a time." },
];

export const MARQUEE_WORDS = [
  "Road", "Air", "Sea", "Rail", "Warehousing", "Express", "Customs", "Pan-India",
];
